import { render, staticRenderFns } from "./ChatMessagesBox.vue?vue&type=template&id=f7e0470a&scoped=true&"
import script from "./ChatMessagesBox.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessagesBox.vue?vue&type=style&index=0&id=f7e0470a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e0470a",
  null
  
)

export default component.exports